import styled from 'styled-components'

import { NEUTRAL_COLOURS } from 'constants/colors'

export const StyledContainer = styled.div`
  background-color: ${NEUTRAL_COLOURS.GRAY_QUATERNARY};
  padding: 22px; 
  margin-top: 20px;
`

export const StyledSignaturePad = styled.div`
  background-color: ${NEUTRAL_COLOURS.WHITE};
`
